import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output
} from '@angular/core';
import {
	EmailReplyMeta,
	IModalAction,
	IProductPackageItem
} from '@models/models';
import { MessageService } from '@services/helpers/message-service/message.service';
import { EmailReplyConfirmModalComponent } from '@web-components/settings/email-settings-section/modals/email-reply-confirm-modal/email-reply-confirm-modal.component';
import { SNModalService } from '@web-services/modal/snModal.service';
import { Subject, Subscription } from 'rxjs';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EmailSettingsDataService } from '@services/settings/email-settings.data.service';
import { EmailSettingsService } from '@services/settings/email-settings.service';
import { filter, finalize, takeUntil } from 'rxjs/operators';

@Component({
	selector: 'reply-track',
	template: require('./reply-track.component.html'),
	styles: [require('./reply-track.component.scss')]
})
export class ReplyTrackComponent implements OnDestroy {
	@Input() id: number;
	@Input() settingsMetadata: EmailReplyMeta;
	@Output() onEmailConfirm: EventEmitter<EmailReplyMeta> = new EventEmitter();

	private confirmModalSub: Subscription;
	private confirmModalRef: NgbModalRef;
	private unsubscribe: Subject<void> = new Subject();

	constructor(
		private messageService: MessageService,
		private modalService: SNModalService,
		private emailSettingsDataService: EmailSettingsDataService,
		private emailSettingsService: EmailSettingsService
	) {}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	getReplyEmailAddress(): string {
		return `${this.settingsMetadata.emailAddress.username}@${
			this.settingsMetadata.emailAddress.domain
		}`;
	}

	copyToClipboard(ev): void {
		ev.preventDefault();
		this.messageService.showToaster('i_1', 'emailSettings');
	}

	submitEmailAddress(): void {
		if (
			!this.emailSettingsService.validateDomain(
				this.settingsMetadata.emailAddress.username.trim()
			)
		) {
			return;
		}

		this.confirmModalRef = this.modalService.openModal(
			EmailReplyConfirmModalComponent,
			{
				windowClass: 'ng-bootstrap-modal__small'
			}
		);

		this.getModalDataForConfirmModal();

		document.body.classList.remove('modal-open');

		this.confirmModalRef.componentInstance.btnDisabled = false;
	}

	private getModalDataForConfirmModal(): void {
		this.confirmModalRef.result.then(
			(): void => {
				document.body.classList.add('modal-open');
				this.confirmModalSub.unsubscribe();
			},
			(): void => {
				document.body.classList.add('modal-open');
				this.confirmModalSub.unsubscribe();
			}
		);

		this.confirmModalSub = this.modalService
			.getModalData()
			.pipe(filter((data): boolean => data && data.action && data.props))
			.subscribe((data: IModalAction<IProductPackageItem>): void => {
				this.confirmModalRef.componentInstance.btnDisabled = true;
				switch (data.action) {
					case 'confirm_email_domain':
						this.saveEmailDomainConfirm();
						break;
					default:
						this.closeConfirmModal();
						break;
				}
			});
	}

	private saveEmailDomainConfirm(): void {
		const email = this.settingsMetadata.emailAddress.username
			.toLowerCase()
			.trim();

		this.emailSettingsDataService
			.saveReplySNEmaiDomain(
				this.settingsMetadata.actions.CREATE_GMAIL_REPLY_ACCOUNT.url,
				email
			)
			.pipe(
				takeUntil(this.unsubscribe),
				finalize((): void => this.closeConfirmModal())
			)
			.subscribe(
				(data: EmailReplyMeta): void => {
					this.messageService.showToaster('s_3', 'emailSettings');
					this.onEmailConfirm.emit(data);
				},
				(err): void => {
					const { error } = err;
					const { errorMessage, errorTitle } = error;
					this.messageService.showErrorFromBackend(errorTitle, errorMessage);
				}
			);
	}

	private closeConfirmModal(): void {
		this.confirmModalRef.componentInstance.btnDisabled = false;
		this.confirmModalRef.close();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/settings/email-settings-section/components/reply-track/reply-track.component.ts